import { lazy } from 'react';

export default [
    {
        path:"/helpdesk",
        component:lazy(() => import('../../views/helpdesks/Help'))
    }
]